module.exports = __webpack_public_path__ + "img/06.1ffa519e.png";